import { render, staticRenderFns } from "./theDocModal.vue?vue&type=template&id=6949b808&"
import script from "./theDocModal.vue?vue&type=script&lang=js&"
export * from "./theDocModal.vue?vue&type=script&lang=js&"
import style0 from "./theDocModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports